import { Loader } from "../customplugins/loader.js";
import { Toaster } from "../customplugins/toaster.js";

document.addEventListener("DOMContentLoaded", () => {


    var resetdata = document.getElementById("hdnForgotPassword") as HTMLElement
    if (resetdata) {
        resetdata.style.display = "none";
    }

    const input = document.getElementById("forgotdistributor") as HTMLInputElement;
    const errorLabel = document.getElementById("lbl_forgotdistributor") as HTMLSpanElement;
    if (errorLabel) {
        errorLabel.style.display = "none";
    }

    input.addEventListener("input", () => {
        const data = input.value.trim();

        if (data === "") {

            errorLabel.style.display = "inline";
        } else {

            errorLabel.style.display = "none";
        }
    });

    input.addEventListener("input", () => {
        if (input.value.trim() !== "") {
            errorLabel.style.display = "none";
        }
    });

});

var data: any;

document.getElementById("btnforgotpassword").addEventListener("click", function () {
    data = (document.getElementById("forgotdistributor") as HTMLInputElement).value.trim();
    getforgotpassword(data);
});


function getforgotpassword(data: any): void {

    if (data == "") {

        var derror = document.getElementById("lbl_forgotdistributor") as HTMLSpanElement;
        if (derror) {
            derror.textContent = "User ID is Required";
            derror.style.display = "block";
        }
        return
    }
    Loader.show();
    var fomdata = new FormData();
    fomdata.append("distributorIdno", data);
    fomdata.append("tenant_id", "0");


    fetch("/CustomerForgotedPassword", {
        method: "POST",

        body: fomdata
    })
        .then(res => res.json())
        .then((response) => {

            if (!response || !response.regid) {

                Toaster.error("Nodata Found");
                Loader.hide();
                return;
            }

            (document.getElementById("txtregid") as HTMLInputElement).value = response.regid.toString();
            (document.getElementById("forgotdistributor") as HTMLInputElement).disabled = true;
            
            (document.getElementById("txtname") as HTMLInputElement).value = response.name;
            (document.getElementById("txtmobile") as HTMLInputElement).value = response.phone;

            (document.getElementById("lblmobile") as HTMLInputElement).value = response.phone;
            (document.getElementById("lblname") as HTMLInputElement).value = response.name;


            var resetdata = document.getElementById("hdnForgotPassword") as HTMLElement
            if (resetdata) {
                resetdata.style.display = "block";

            }
            var forgotbtn = document.getElementById("btnforgotpassword") as HTMLButtonElement
            if (forgotbtn) {
                forgotbtn.style.display = "none";

            }
            if (response?.phone?.trim()) {
                sentotpforgotpassword();
                Loader.hide();
            }
            Loader.hide();
        });


}


const mobileInput = document.getElementById("txtmobile") as HTMLInputElement;
const sendOtpBtn = document.getElementById("sendOtpBtn") as HTMLButtonElement;
const otpSection = document.getElementById("otpSection") as HTMLElement;
const otpInput = document.getElementById("otpInput") as HTMLInputElement;
const verifyOtpBtn = document.getElementById("verifyOtpBtn") as HTMLButtonElement;
const resendOtpBtn = document.getElementById("resendOtpBtn") as HTMLButtonElement;

function isValidMobile(mobile: string): boolean {
    return /^[6-9]\d{9}$/.test(mobile);
}


function sentotpforgotpassword() {
    debugger
    const sendOtpBtn = document.getElementById("sendOtpBtn") as HTMLButtonElement;
    const nameInput = document.getElementById("lblname") as HTMLInputElement;
    const name = nameInput.value.trim();
    const enteredMobile = mobileInput.value.trim();
    if (!isValidMobile(enteredMobile)) {
        Toaster.error("Enter valid 10-digit mobile number");
        return;
    }


    fetch(`/CommonSendOtp?Name=${encodeURIComponent(name)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            Mobileno: enteredMobile,
            Message: name
        })
    })
        .then(response => response.json())
        .then(result => {
            debugger
            if (result.success) {
                Toaster.success(result.message);
                otpSection.style.display = "block";

                startResendCooldown();
            } else {
                Toaster.error(result.message || "Failed to send OTP");
            }
        })

}



var ismobilecheck = false;
verifyOtpBtn?.addEventListener("click", async () => {

    const otp = otpInput.value.trim();
    if (otp.length !== 6) {
        Toaster.error("Enter valid OTP");
        return;
    }


    try {
        verifyOtpBtn.disabled = true;
        const response = await fetch("/VerifyOtp", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                Otp: otp,
                MobileNo: mobileInput.value.trim()
            })
        });
        const result = await response.json();
        debugger
        if (result.success) {

            otpSection.style.display = "none";
            ismobilecheck = true;
            mobileInput.disabled = true;

            Toaster.success("OTP verified successfully");
            Loader.hide();

            newpasswordgenerate();
        } else {

            Toaster.error(result.message || "Invalid OTP");
            resendOtpBtn.style.display = "inline-block";
        }


    } catch (error) {
        debugger

        Toaster.error("OTP verification failed");

    } finally {
        verifyOtpBtn.disabled = false;
    }
});
resendOtpBtn?.addEventListener("click", async () => {
    const nameInput = document.getElementById("lblname") as HTMLInputElement;
    const name = nameInput.value.trim();
    if (!mobileInput.value.trim()) {
        Toaster.error("Mobile missing");
        return;
    }
    try {
        resendOtpBtn.disabled = true;

        // const response = await fetch("/CommonSendOtp", {
        const response = await fetch(`/CommonSendOtp?Name=${encodeURIComponent(name)}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                Mobileno: mobileInput.value.trim(),
                Message: name
            })
        });

        const result = await response.json();

        if (result.success) {


            Toaster.success(`${result.message}`);

            otpInput.value = "";
            startResendCooldown();
        } else {
            Toaster.error(result.message || "Resend failed");
        }

    } catch (error) {
        console.error(error);
    } finally {
        resendOtpBtn.disabled = false;
    }
});
function startResendCooldown(): void {
    let seconds = 30;

    resendOtpBtn.style.display = "inline-block";
    resendOtpBtn.disabled = true;

    const interval = setInterval(() => {
        resendOtpBtn.textContent = `Resend OTP (${seconds}s)`;
        seconds--;

        if (seconds < 0) {
            clearInterval(interval);
            resendOtpBtn.disabled = false;
            resendOtpBtn.textContent = "Resend OTP";
        }
    }, 1000);
}



function newpasswordgenerate(): void {
    Loader.show();
    var regid = (document.getElementById("txtregid") as HTMLInputElement).value.trim();
    var name = (document.getElementById("txtname") as HTMLInputElement).value.trim();
    var mobile = (document.getElementById("txtmobile") as HTMLInputElement).value.trim();

    var fomdata = new FormData();
    fomdata.append("UserId", data);
    fomdata.append("regid", regid);
    fomdata.append("name", name);
    fomdata.append("mobile", mobile);

    fetch("/CustomerOpensitenewPassword", {
        method: "POST",

        body: fomdata
    })
        .then(res => res.json())
        .then((response) => {

            if (response.status === "error") {
                Loader.hide();
                Toaster.error("Please Try Again");
               
                    window.location.href = "/PreferredLogin";
                    return;
                
               

            }
            else {
                Loader.hide();
                window.location.href = "/PreferredLogin";
            }

        });


} 